import { Channels, type Offices } from 'constants/enums'
import type { Market } from 'services/shared/commercialStructure/interfaces'
import { useSelector } from 'store/store'

export const useCommercialStructure = () => {
  const { offices, regionals, zones, bmus, commercialStructure, hasCommercialStructure } =
    useSelector((state) => state.shared)

  const getMarkets = () => {
    // TODO: Update this to use from redux when backend is ready
    const marketENUMS = Object.keys(Channels) as Channels[]

    const markets = marketENUMS.map((market) => ({
      description: market,
      id: market,
    })) as Market[]

    return markets
  }

  const getOffices = () => {
    return offices
  }

  const getRegionals = () => {
    return regionals
  }

  const getZones = () => {
    return zones
  }

  const getBMUs = () => {
    return bmus
  }

  const getOfficesByBMU = (bmuCode: string) => {
    const officeIdsForBMU = commercialStructure
      .filter((entry) => entry.CodigoUnidadeNegocio === bmuCode)
      .map((entry) => entry.CodigoEscritorio)

    const uniqueOfficeIds = [...new Set(officeIdsForBMU)]

    return offices.filter((office) => uniqueOfficeIds.includes(office.id))
  }

  const getOfficesByMarkets = (markets: Channels[]) => {
    const filteredOffices = offices.filter((office) => {
      return markets.includes(office.idMarket)
    })

    return filteredOffices
  }

  const getRegionalsByOffices = (offices: Offices[]) => {
    return regionals.filter((regional) => offices.includes(regional.idOffice as Offices))
  }

  const getZonesByRegionals = (regions: string[]) => {
    return zones.filter((zone) => regions.includes(zone.idRegional))
  }

  const getDirectorByOffice = (officeId: Offices) => {
    const office = offices.find((office) => office.id === officeId)
    return office?.directorName || ''
  }

  return {
    getBMUs,
    getDirectorByOffice,
    getMarkets,
    getOffices,
    getOfficesByBMU,
    getOfficesByMarkets,
    getRegionals,
    getRegionalsByOffices,
    getZones,
    getZonesByRegionals,
    hasCommercialStructure,
  }
}
